import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-114ac2a3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "numbercom-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "模糊测试智能体", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "国际公认的先进技术", -1));
const _hoisted_4 = {
  class: "statistics"
};
const _hoisted_5 = {
  class: "project"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "projectTitle"
}, [/*#__PURE__*/_createTextVNode("发现Office"), /*#__PURE__*/_createElementVNode("span", null, "安全缺陷")], -1));
const _hoisted_7 = {
  class: "defectsNumber"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "+", -1));
const _hoisted_9 = {
  class: "icon",
  alt: "云起无垠"
};
const _hoisted_10 = {
  class: "project"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "projectTitle"
}, [/*#__PURE__*/_createTextVNode("发现Linux"), /*#__PURE__*/_createElementVNode("span", null, "安全缺陷")], -1));
const _hoisted_12 = {
  class: "defectsNumber"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "+", -1));
const _hoisted_14 = {
  class: "icon",
  alt: "云起无垠"
};
const _hoisted_15 = {
  class: "project"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "projectTitle"
}, [/*#__PURE__*/_createTextVNode(" 发现现代浏览器中的"), /*#__PURE__*/_createElementVNode("span", null, "安全缺陷")], -1));
const _hoisted_17 = {
  class: "defectsNumber"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "+", -1));
const _hoisted_19 = {
  class: "icon",
  alt: "云起无垠"
};
const _hoisted_20 = {
  class: "project"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "projectTitle"
}, [/*#__PURE__*/_createTextVNode(" DIU（美国国防部直属部门）"), /*#__PURE__*/_createElementVNode("span", null, "投入")], -1));
const _hoisted_22 = {
  class: "defectsNumber"
};
const _hoisted_23 = {
  class: "icon",
  alt: "云起无垠"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_lazy = _resolveDirective("lazy");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("p", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(_ctx.officeNumber), 1), _createTextVNode(" 个 "), _hoisted_8]), _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [[_directive_lazy, require('@/assets/img/index/office.png')]])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("p", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(_ctx.linuxNumber), 1), _createTextVNode(" 个 "), _hoisted_13]), _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [[_directive_lazy, require('@/assets/img/index/linux.png')]])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("p", _hoisted_17, [_createElementVNode("span", null, _toDisplayString(_ctx.webNumber), 1), _createTextVNode(" 个 "), _hoisted_18]), _withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [[_directive_lazy, require('@/assets/img/index/google.png')]])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("p", _hoisted_22, [_createElementVNode("span", null, _toDisplayString(_ctx.DIUNumber), 1), _createTextVNode(" $ ")]), _withDirectives(_createElementVNode("img", _hoisted_23, null, 512), [[_directive_lazy, require('@/assets/img/index/diu.png')]])])])])), [[_directive_lazy, require('@/assets/img/index/number-bg.png'), "background-image"]]);
}